import React from "react";
import {connect} from "dva";
import {modelUtils} from "@/utils";
import {component_tool, framework_tool, utils_tool} from "@/tool";
import createColumns from "./listSelectColumns";

const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizButton,
  WizModalForm,
  WizAlert,
  WizModalTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const {WizContainer} = framework_tool;
const {getPageData, checkStrLength} = utils_tool;

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    // updateUser: this._userOnChange.bind(this),
    // addUser: this._userOnChange.bind(this)
  };

  _userOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _userOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    const {groupId} = this.props;
    const groupIdList = [];
    groupIdList.push(groupId);
    this.doAction({
      path: "userManagement/getUserListByGroupPlugPage",
      payload: {
        key: "userListKey@" + groupId,
        apiParams: {...this.state.apiParams, ...other,groupIdList:groupIdList}
      }
    });
  };

  _render() {
    const {userList, userManagementLoading, selectedRows, updateRows, handleClear} = this.props;
    const {record, visible} = this.state;
    const dataItems = getPageData(userList.data);
    const other = {};
    const columns = createColumns(this, dataItems, other);
    const searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({apiParams: values}, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: userManagementLoading,
      columns,
      rowKey: "personId",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        this._getData({current: pageNum, size: pageSize});
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        updateRows(rows)
      }
    };

    const listSelectProps = {
      type:'人员',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    };

    return (
      <WizRow>
        <WizCol span={16}>
          <WizCard bodyStyle={{padding: '0 15px'}}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{xs: 16, md: 12, xl: 10}}
            />
            <WizDataTable style={{marginTop: 15}} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={8}>
          <WizListSelect {...listSelectProps} />
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {userManagement} = state;
  const userList = modelUtils.getModelEntity(userManagement, "userListKey@" + ownProps.groupId);
  const load = modelUtils.getLoadingState(state, "userManagement");
  return {
    userList: userList,
    ...load
  };
};


export default connect(mapStateToProps)(ListSelect);
